import { TFunction } from "i18next";

import { GenderEnum } from "src/core/constants/folder";

export const getGenderOptions = (t: TFunction) =>
  Object.entries(GenderEnum).map(([key, value]) => ({
    label: t(`enum.gender.${key}`),
    value: value,
  }));
